import React, { useCallback } from 'react';
import TimeSpanChip from './TimeSpanChip';
import { formatTimeSpans } from './utils';

export interface TimeSpanChipListProps {
  timeSpans: {
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
    days: string;
  }[];
  onDelete?: (idx: number) => void;
}

export const TimeSpanChipList: React.FC<TimeSpanChipListProps> = ({
  timeSpans,
  onDelete,
}) => {
  const formattedTimeSpans = formatTimeSpans(timeSpans);

  return (
    <>
      {formattedTimeSpans.map((span, idx) => {
        return (
          <TimeSpanChip
            key={idx}
            label={span}
            onDelete={onDelete ? () => onDelete(idx) : undefined}
          />
        );
      })}
    </>
  );
};
export default TimeSpanChipList;
